import {
  TradeTalkFormFields,
  TradeTalkLabels,
  TradeTalkPrivacy,
  TradeTalkStrategy,
  TradeTalkType,
} from '@monorepo/client-types';
import { PagePath } from '@monorepo/client-types';
import { IconsNames } from '@monorepo/types';

export const formDefaultValues: TradeTalkFormFields = {
  title: '',
  description: '',
  privacy: TradeTalkPrivacy.Public,
  type: TradeTalkType.Analysis,
  strategy: TradeTalkStrategy.Long,
  categoriesId: [],
  categoriesNames: [],
  tags: [],
  chartData: undefined,
};

export const formErrors = {
  titleExists: {
    error: 'Idea with this name already exists for this user',
    message: 'Trade Talk with this name already exists',
  },
};

export const PAGINATION_PARAMS = { SKIP: 0, LIMIT: 20 };

export const COMMENTS_PAGINATION_PARAMS = { SKIP: 0, LIMIT: 6 };

export const feedsNames = {
  picks: 'picks',
  myTalks: 'my-talks',
};

export const feedSearchParams = {
  textSearch: 'search',
  feedName: 'feed',
  authorId: 'author-id',
  sortByOption: 'sort-by',
} as const;

const myTradeTalksParams = new URLSearchParams({
  [feedSearchParams.feedName]: feedsNames.myTalks,
});
export const pathToMyTradeTalks = `${PagePath.TradeTalk}?${myTradeTalksParams.toString()}`;

export type TradeTalkFeedOption = {
  label: TradeTalkLabels;
  feed?: (typeof feedsNames)[keyof typeof feedsNames];
  icon?: IconsNames;
};

export const tradeTalkFeedsOptionsForGuests: TradeTalkFeedOption[] = [
  {
    label: TradeTalkLabels.AllTalks,
    feed: undefined,
    icon: IconsNames.MegaphoneNew,
  },
  // Two options for now
  // {
  //   label: TradeTalkLabels.Picks,
  //   feed: feedsNames.picks,
  // },
];

export const tradeTalkFeedsOptions: TradeTalkFeedOption[] = [
  ...tradeTalkFeedsOptionsForGuests,
  {
    label: TradeTalkLabels.MyTradeTalk,
    feed: feedsNames.myTalks,
    icon: IconsNames.User,
  },
];

export const TUTORIAL_VIDEO_STATE_KEY = 'tutorial_video_state';
export const TUTORIAL_VIDEO_MOUNTED_KEY = 'tutorial_video_mounted_first_visit';

export const TOUR_KEY = `tour_watched`;

export const sortByOptions = {
  popularity: 'popularity',
  releaseDate: 'releaseDate',
} as const;

export const getShareOptionLabel = (platform: string): string => {
  if (platform.toLowerCase() === 'twitter') return 'X';
  if (platform.toLowerCase() === 'link') return 'Copy Link';
  return platform.charAt(0).toUpperCase() + platform.slice(1);
};
